<template>
    <div :class="`reference control-${mode}`">
        <!-- 多选模式 -->
        <div
            v-if="multiple"
            class="reference-multiple"
        >
            <dsh-buttons
                class="reference-multiple-btns"
                itemClass="reference-btns-item"
                :list="$getOperationList(['canRelate'])"
                @click="$dispatchEvent($event)"
            ></dsh-buttons>

            <div class="reference-multiple-header">
                <span>{{ `已选择 ${val.length} 条` }}</span>
                <dsh-buttons
                    v-if="val.length"
                    class="reference-multiple-btns"
                    itemClass="reference-btns-item"
                    :list="$getOperationList(['canBatchCancelRelate'])"
                    @click="$dispatchEvent($event)"
                ></dsh-buttons>
            </div>

            <dsh-box
                v-if="val.length"
                class="reference-multiple-list"
                :columns="mulSelfColumns"
                :data="val"
                :listPropsObj="listPropsObj"
                @clickRow="clickRow"
                @selectChange="changeSelect"
            ></dsh-box>

            <!-- 暂无数据 -->
            <div
                v-else
                class="nodata"
                :style="{ 'background-image': `url(${$imageSrcMap.app.nodata})`}"
            ></div>
        </div>

        <!-- 单选模式 -->
        <div
            v-else
            class="reference-single"
        >
            <!-- 已选择 -->
            <div
                v-if="val"
                class="reference-single-content"
            >
                <!-- 删除 -->
                <dsh-icons
                    class="reference-single-icons"
                    itemClass="reference-icons-item"
                    :list="$getOperationList(['canCancelRelate'])"
                    @click="$dispatchEvent($event)"
                ></dsh-icons>

                <!-- 内容 -在列表里的展示 -->
                <Ctooltip
                    v-if="inTable"
                    placement="top"
                    :transfer="true"
                    :content="showName || '单条关联'"
                >
                    <div
                        class="reference-single-content-table"
                        @click="clickModName(val)"
                    >
                        <Icon
                            class="reference-single-content-table-icon"
                            type="ios-link"
                        />
                        <span class="reference-single-content-table-name">{{ showName || "单条关联" }}</span>
                    </div>
                </Ctooltip>

                <!-- 内容 -在表单里的展示 -->
                <template v-else>
                    <!-- 表单展示模式 -->
                    <template v-if="exhibitionType === 'form'">
                        <dsh-form
                            class="reference-single-content-form"
                            :canEdit="false"
                            :formData="value[propsObj._key]"
                            :formList="curScreenShowFormList"
                            :allFormList="curScreenShowFormList"
                            @click.native="clickRow(val)"
                        ></dsh-form>
                    </template>
                    <!-- 列表展示模式 -->
                    <dsh-box
                        v-else
                        class="reference-single-content-box"
                        :data="[val]"
                        :columns="lessColumns"
                        :listPropsObj="listPropsObj"
                        @clickRow="clickRow"
                    ></dsh-box>
                </template>
            </div>

            <!-- 未选择 -->
            <dsh-buttons
                v-else
                class="reference-single-btns"
                itemClass="reference-btns-item"
                :list="$getOperationList(['canRelate'])"
                @click="$dispatchEvent($event)"
            ></dsh-buttons>
        </div>

        <!-- 编辑模态框 -->
        <dsh-render :render="updateModalRender"></dsh-render>

        <!-- 列表模态框 -->
        <sheet-select-modal
            v-if="showSheetSelectModal"
            v-model="showSheetSelectModal"
            :multiple="multiple"
            :useCreate="useCreate"
            :defaultModObj="modObj"
            :propsObj="propsObj"
            :defaultSearchParams="sheetModalSearchParams"
            @selectRow="relate"
            @batchSelect="batchRelate"
        ></sheet-select-modal>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";
    import sheetMixin from "@/mixins/sheet/sheetMixin.js";

    export default {
        name: "reference",
        mixins: [controlMixin, sheetMixin],
        components: {},
        props: {},
        data () {
            return {
                record: {
                    delete: [],
                    create: []
                },
                isRef: true
            };
        },
        computed: {
            val: {
                get () {
                    return this.value[this.propsObj._key];
                },
                set (val) {
                    this.value[this.propsObj._key] = val;
                }
            },
            showName () {
                let content = this.val && this.val._name;
                if (content && content._name) {
                    content = content._name;
                } else if (Array.isArray(content) && content.length) {
                    content = content[0].name;
                }

                return content;
            },

            stopModInit () {
                return this.inTable;
            },
            // 展示类型 默认展示表格类型
            exhibitionType () {
                return this.propsObj._exhibitionType;
            },
            multiple () {
                return !!this.propsObj._multiple;
            },
            useCreate () {
                return this.propsObj._useCreate;
            },
            otoField () {
                return this.propsObj._otoField;
            },

            sheetModalSearchParams () {
                return {
                    $or: [
                        {
                            [this.otoField]: this.propsObj._useOtoField !== false && this.otoField ? { $eq: null } : undefined,
                            _id: {
                                $nin: this.record.create
                            }
                        },
                        {
                            _id: {
                                $in: this.record.delete
                            }

                        }
                    ]
                };
            },
            mulSelfColumns () {
                return this.lessColumns
                    .slice(0, 2)
                    .concat(this.$createOperationCol(["canCancelRelateRow"]));
            },
            listPropsObj () {
                return {
                    multiple: this.multiple,
                    useColBg: false
                };
            },

            // // 需要时候打开注释
            // selfBtnOperationMap () {
            //     return {};
            // },
            allOperationMap () {
                return {
                    ...this.baseOperationMap,

                    canRelate: {
                        name: `关联${this.modName}`,
                        type: "canRelate",
                        icon: "md-add",
                        long: true,
                        disabled: !this.finalCanEdit || !this.modName,
                        event: this.finalCanEdit && this.modName ? "openSheetSelectModal" : ""
                    },
                    canCancelRelate: {
                        name: "取消关联",
                        type: "canCancelRelate",
                        icon: "md-trash",
                        size: "16",
                        event: "cancelRelate"
                    },

                    canCancelRelateRow: {
                        name: "删除",
                        type: "canCancelRelateRow",
                        btnType: "text",
                        size: "small",
                        icon: "md-trash",
                        event: "cancelRelateRow"
                    },
                    canBatchCancelRelate: {
                        name: "批量删除",
                        type: "canBatchCancelRelate",
                        btnType: "text",
                        size: "small",
                        icon: "md-trash",
                        event: "batchCancelRelate"
                    }
                };
            },
            operationMap () {
                if (this.finalCanEdit) {
                    return this.allOperationMap;
                } else {
                    return this.$categoryMapToMap(
                        this.allOperationMap,
                        null,
                        [],
                        ["canShow", "canRelate"] // 尽管没有clickRelate权限，但需要出现，只需要按钮式disabled
                    );
                }
            }
        },
        created () {},
        methods: {
            clickModName (dataItem) {
                this.dataItem = dataItem;
                this.getModData();
            },
            // 此方法目前只为处理 内部表格和级联表格里的单挑关联字段
            getModAfter () {
                if (this.stopModInit === true) {
                    this.clickRow(this.dataItem);
                }
            },

            /* ------- 单选模式 -------- */
            // 关联某项
            relate (dataItem) {
                [dataItem._id].forEach(dataId => {
                    if (this.record.delete.includes(dataId)) {
                        this.record.delete = this.record.delete.filter(_id => _id !== dataId);
                    } else {
                        this.record.create.push(dataId);
                    }
                });
                this.val = dataItem;

                this.change();
            },
            // 取消关联某项
            cancelRelate (operationItem) {
                [this.val._id].forEach(dataId => {
                    if (this.record.create.includes(dataId)) {
                        this.record.create = this.record.create.filter(_id => _id !== dataId);
                    } else {
                        this.record.delete.push(dataId);
                    }
                });
                this.val = null;

                this.change();
            },

            /* ------- 多选模式 -------- */
            // 批量关联
            batchRelate (selectIds, selections) {
                selections.forEach(selectionItem => {
                    if (!this.val.find(item => item._id === selectionItem._id)) {
                        this.val.push(selectionItem);
                    }
                });

                this.change();
            },
            // 批量取消关联
            batchCancelRelate (operationItem) {
                this.selectIds.forEach((id, index) => {
                    let valIndex = this.val.findIndex(item => item._id === id);
                    if (valIndex > -1) {
                        this.val.splice(valIndex, 1);
                    }
                });

                this.change();
            },
            // 取消关联某行
            cancelRelateRow (operationItem, row, index) {
                this.val.splice(index, 1);

                this.change();
            },
            updateCb (dataItem) {
                this.val = dataItem;
                this.change();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/controls/sheet/reference.vue